import React from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarContent,
  SubMenu,
} from "react-pro-sidebar";
import { Link } from "react-router-dom";

import { useSelector } from "react-redux";
import { withRouter } from "react-router";

const SidebarClimate = (props) => {
  const userId = useSelector((store) => store.auth.id);
  const userType = useSelector((store) => store.auth.userType);
  const userRoles = useSelector((store) => store.auth.userRoles);

  return (
    <>
      <ProSidebar
        collapsed={false}
        className={`custom-sidebar ${props.show ? "show-sidebar" : ""}`}
        toggled={"fixed"}
      >
        <SidebarContent style={{ overflowY: "auto" }}>
          <Menu iconShape="square">
            <MenuItem icon={<i className="material-icons">face</i>}>
              <Link to={`/detalle-empleado/${userId}/${userType}`}>
                Ficha de empleado
              </Link>
            </MenuItem>
            {userRoles.length > 0 && userRoles.includes("administrador") && (
              <>
                <MenuItem icon={<i className="material-icons">workspaces</i>}>
                  <Link to={`/workflow`}>Plantillas WorkFlows</Link>
                </MenuItem>
                <div className="py-3 px-4 text-muted">OnBoarding</div>
                <MenuItem icon={<i className="material-icons">waving_hand</i>}>
                  <Link to={`/Mantenimiento-Bienvenida`}>Bienvenida</Link>
                </MenuItem>
              </>
            )}
            {/* <div className="py-3 px-4 text-muted">OffBoarding</div>
            {userRoles.length > 0 &&
            (userRoles.includes("Responsable_Sanciones") ||
              userRoles.includes("administrador")) ? (
              <>
                <SubMenu
                  title="Módulo Disciplinario"
                  icon={<i className="material-icons">gavel</i>}
                >
                  <MenuItem>
                    <Link to={`/categorias-desvinculación`}>
                      Categoría de Desvinculación
                    </Link>
                  </MenuItem>
                  <MenuItem>
                    <Link to={`/motivo-acciones-disciplinarias`}>
                      Motivo Disciplinario
                    </Link>
                  </MenuItem>
                  <MenuItem>
                    <Link to={`/tipos-acciones-disciplinarias`}>
                      Tipos de acciones
                    </Link>
                  </MenuItem>
                  <MenuItem>
                    <Link to={`/medidas-disciplinarias`}>
                      Medidas Disciplinarias
                    </Link>
                  </MenuItem>
                  <MenuItem>
                    <Link to={`/tipo-falta`}>Tipo Falta</Link>
                  </MenuItem>
                  <MenuItem>
                    <Link to={`/sansiones-estatus`}>Estatus</Link>
                  </MenuItem>
                  <MenuItem>
                    <Link to={`/sansiones-formatos/1`}>Formatos</Link>
                  </MenuItem>
                </SubMenu>
              </>
            ) : null}
            {userRoles.length > 0 &&
              (userRoles.includes("Responsable_Sanciones") ||
                userRoles.includes("Encargado_Sanciones") ||
                userRoles.includes("administrador") ||
                userRoles.includes("jefe")) && (
                <SubMenu
                  title="Medidas Disciplinarias"
                  icon={<i className="material-icons">pan_tool</i>}
                >
                  {userRoles.length > 0 &&
                    (userRoles.includes("Responsable_Sanciones") ||
                      userRoles.includes("Encargado_Sanciones") ||
                      userRoles.includes("administrador") ||
                      userRoles.includes("jefe")) && (
                      <MenuItem>
                        <Link to={`/casos-disciplinarios`}>
                          Casos Disciplinarios
                        </Link>
                      </MenuItem>
                    )}
                  {userRoles.length > 0 &&
                  (userRoles.includes("Encargado_Sanciones") ||
                    userRoles.includes("administrador") ||
                    userRoles.includes("jefe")) ? (
                    <>
                      <MenuItem>
                        <Link to={`/acciones-disciplinarias`}>
                          Acciones Disciplinarias
                        </Link>
                      </MenuItem>
                    </>
                  ) : null}
                </SubMenu>
              )} */}
          </Menu>
        </SidebarContent>
      </ProSidebar>
      <div
        onClick={() => props.onShowSidebar()}
        className={`overlay ${props.show ? "show-overlay" : ""}`}
      ></div>
    </>
  );
};

export default withRouter(SidebarClimate);
